var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetBio2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7194 0.187625H2.46283C1.55084 0.187625 0.811523 0.926941 0.811523 1.83893V16.3487C0.811523 17.2607 1.55084 18 2.46283 18H10.7194C11.6314 18 12.3707 17.2607 12.3707 16.3487V1.48692C12.3707 0.574925 11.6314 0.187625 10.7194 0.187625ZM2.08723 1.48692L4.11382 1.48821C4.11382 2.47899 5.30945 2.47899 5.76545 2.47899H7.41676C7.87275 2.47899 9.06774 2.47899 9.06774 1.48821L11.0924 1.48692V16.7135H2.08723V1.48692Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.08617 9.28097C8.45416 9.28097 9.56314 10.3899 9.56314 11.7579V12.7487H3.61843V11.7579C3.61843 10.3899 4.7274 9.28097 6.09539 9.28097H7.08617ZM6.59062 5.81387C7.41141 5.81387 8.0768 6.47925 8.0768 7.30004C8.0768 8.12084 7.41141 8.78622 6.59062 8.78622C5.76983 8.78622 5.10444 8.12084 5.10444 7.30004C5.10444 6.47925 5.76983 5.81387 6.59062 5.81387Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetBio2);
export default __webpack_public_path__ + "static/media/SET-Bio2.080ce974.svg";
export { ForwardRef as ReactComponent };